<template>
  <div class="dropdown" :class="{ 'is-active': isActive }">
    <div class="dropdown-trigger">
      <button
        class="button px-1 flag"
        aria-haspopup="true"
        aria-controls="dropdown-menu"
        @click="showDropdown()"
      >
        <img
          height="30"
          width="30"
          :src="
            countryFlag
              ? countryFlag
              : 'https://api.rojgari.com/static/country/nepal.svg'
          "
          alt=""
          class="mx-1 flag"
        />
        {{ dial_code ? dial_code : '+977' }}
        <span>
          <a class="has-text-success">
            <vue-icon-base
              height="16"
              width="16"
              :path="$options.icons[$kc('uni-angleDown')]"
              icon-color="green"
              class="flag"
            >
            </vue-icon-base>
          </a>
        </span>
      </button>
    </div>
    <div id="dropdown-menu" class="dropdown-menu" role="menu">
      <div class="dropdown-content drop">
        <div class="control">
          <div class="input-group-prepend">
            <input v-model="search" class="input flag-input" @keyup="getList" />
          </div>
          <a
            v-for="item in items"
            :key="item.id"
            class="dropdown-item is-clickable"
            @click="selectValue(item)"
          >
            <div class="row drop-flag is-flex">
              <div class="is-flex">
                <div>
                  <img
                    height="14px"
                    width="20px"
                    :src="`https://api.rojgari.com/static/country/${convertToSlug(
                      item.name
                    )}.svg`"
                    class="mt-0"
                  />
                </div>
                <div class="ml-3">
                  {{ item.name }}
                </div>
              </div>
              <div class="is-pulled-right">
                <div class="">
                  {{ item.dial_code }}
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueIconBase from '@/components/Commons/VueIconBase'
import { uniAngleDown, uniAngleUp } from '@/helpers/icons'
export default {
  icons: {
    uniAngleDown,
    uniAngleUp
  },
  components: {
    VueIconBase
  },
  props: {
    endpoint: {
      type: String,
      default: ''
    },
    keyword: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      countryFlag: null,
      dial_code: null,
      search: '',
      isActive: false,
      hideDropdown: false,
      items: [],
      formValues: {
        country: { name: 'Nepal', id: 1, dial_code: '+977' }
      },
      loading: false,
      selectedObject: []
    }
  },
  watch: {
    isActive(isActive) {
      if (isActive) {
        document.addEventListener('click', this.closeDropdown)
      }
    },
    'formValues.country': {
      handler(val) {
        if (val) {
          const flag = this.convertToSlug(val.name)
          this.countryFlag = `https://api.rojgari.com/static/country/${flag}.svg`
          this.dial_code = val.dial_code
        }
      }
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      this.$axios
        .get(`${this.endpoint}?search=${this.search}`)
        .then(response => {
          this.items = response.data.results
        })
    },
    selectValue(obj) {
      this.formValues.country = {
        id: obj.id,
        name: obj.name,
        dial_code: obj.dial_code
      }
      this.isActive = false
      this.$emit('country', obj.name)
    },
    convertToSlug(Text) {
      if (Text) {
        return Text.toString()
          .toLowerCase()
          .replace(/ /g, '-')
          .replace(/[^\w-]+/g, '')
      }
    },
    showDropdown() {
      this.isActive = true
    },
    closeDropdown(event) {
      if (event.target.classList.contains('flag')) {
        this.isActive = true
      } else if (
        !event.target.classList.contains('dropdown-item') &&
        !event.target.classList.contains('flag-input')
      ) {
        this.isActive = false
      }
    }
  }
}
</script>

<style scoped>
.drop {
  width: 300px;
}
.drop-flag {
  justify-content: space-between;
}
</style>
